import { StatePropertyRef } from '../../canvas/ExtendableStore';

export interface ActiveSketchInfo {
    sketchId: string;
}

export const CreateActiveSketchInfo = (sketchId: string) => ({ sketchId }) as ActiveSketchInfo;

export const ActiveSketchInfo = StatePropertyRef<ActiveSketchInfo>('activeSketch', CreateActiveSketchInfo(null));
